import styled from "styled-components";
export const Form = styled.form `
  width: 100%;
`;
export const Settings = styled.div `
  margin-bottom: 20px;
`;
